import { SendFailure } from 'src/app/admin-api';

export type FailExportGroupBy = 'none' | 'robot' | 'reason';

export interface FailExportGroup {
  groupKey: string;
  groupLabel: string;
  count: number;
  failures: SendFailure[];
}

const EMPTY_ROBOT_LABEL = '(sem robô)';
const EMPTY_REASON_LABEL = '(sem motivo)';

function resolveGroupLabel(
  value: string | undefined | null,
  emptyLabel: string
): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : emptyLabel;
}

/**
 * Groups fail-export rows by robot (`descriptionBot`) or reason (`payloadError`).
 * When groupBy is `none`, returns an empty array (caller should use the flat list).
 */
export function groupFailExports(
  failures: SendFailure[] | null | undefined,
  groupBy: FailExportGroupBy
): FailExportGroup[] {
  if (!failures?.length || groupBy === 'none') {
    return [];
  }

  const emptyLabel =
    groupBy === 'robot' ? EMPTY_ROBOT_LABEL : EMPTY_REASON_LABEL;
  const field: keyof SendFailure =
    groupBy === 'robot' ? 'descriptionBot' : 'payloadError';

  const groups = new Map<string, FailExportGroup>();

  for (const failure of failures) {
    const groupLabel = resolveGroupLabel(
      failure[field] as string | undefined,
      emptyLabel
    );
    const existing = groups.get(groupLabel);
    if (existing) {
      existing.failures.push(failure);
      existing.count = existing.failures.length;
      continue;
    }
    groups.set(groupLabel, {
      groupKey: groupLabel,
      groupLabel,
      count: 1,
      failures: [failure]
    });
  }

  return Array.from(groups.values()).sort((a, b) =>
    a.groupLabel.localeCompare(b.groupLabel, 'pt-BR', { sensitivity: 'base' })
  );
}
